import React from 'react';
import { NewHero } from '../components/NewHero';
import { AtAGlance } from '../components/AtAGlance';
import { NewProblemSection } from '../components/NewProblemSection';
import { AlexandriaSection } from '../components/AlexandriaSection';
import { PSIGatheringSection } from '../components/PSIGatheringSection';
import { PSIProDifferenceSection } from '../components/PSIProDifferenceSection';
import { PSIProBenefitsSection } from '../components/PSIProBenefitsSection';
import { PeptideMasteryDetailSection } from '../components/PeptideMasteryDetailSection';
import { DirectAccessSection } from '../components/DirectAccessSection';
import { QualificationAndFAQSection } from '../components/QualificationAndFAQSection';
import { FinalPostscriptsSection } from '../components/FinalPostscriptsSection';
import { PeptideMasteryComponent } from '../components/PeptideMasteryComponent';
import { FreeOfferReveal } from '../components/FreeOfferReveal';
import { InvestmentSection } from '../components/InvestmentSection';
import { QualificationSection } from '../components/QualificationSection';
import { NoGuarantee } from '../components/NoGuarantee';
import { NewTestimonials } from '../components/NewTestimonials';
import { StakesSection } from '../components/StakesSection';
import { FinalCTA } from '../components/FinalCTA';
import { MysteryLayer } from '../components/MysteryLayer';
import { StickyHeader } from '../components/StickyHeader';
export function NewLandingPage() {
  return <div className="bg-black text-stone-200 min-h-screen relative overflow-x-hidden" data-id="element-2939" data-mp="oxp2xr0l3a38">
      <StickyHeader data-id="element-2940" data-mp="a0pmddnr86wm" />
      <MysteryLayer data-id="element-2941" data-mp="a17pmu8u3le1" />
      <NewHero data-id="element-2942" data-mp="a1r6s8qnu5r0" />
      <AtAGlance data-id="element-2943" data-mp="a293f6h8ilzg" />
      <NewProblemSection data-id="element-2944" data-mp="a2so2uy9roh6" />
      <AlexandriaSection data-id="element-2945" data-mp="eziz33v7vtvq" />
      <PSIGatheringSection data-id="element-2946" data-mp="f0u4t9883bph" />
      <PSIProDifferenceSection data-id="element-2947" data-mp="f016mwnbxuiy" />
      <PSIProBenefitsSection data-id="element-2948" data-mp="24epfinwpouc8" />
      <PeptideMasteryDetailSection data-id="element-2949" data-mp="24eh12rkxxgyx" />
      <DirectAccessSection data-id="element-2950" data-mp="24fidp0hlubir" />
      <QualificationAndFAQSection data-id="element-2951" data-mp="29dtnjb7wgm0z" />
      <FinalPostscriptsSection data-id="element-2952" data-mp="29cqyz9y1uvo8" />
      <PeptideMasteryComponent data-id="element-2953" data-mp="29d0pqzqx56uz" />
      <FreeOfferReveal data-id="element-2954" data-mp="27wd7cihqnqkr" />
      <InvestmentSection data-id="element-2955" data-mp="27wwo3vvnk8x7" />
      <QualificationSection data-id="element-2956" data-mp="27y7rhul6rens" />
      <NoGuarantee data-id="element-2957" data-mp="27ua95b6fmr4y" />
      <NewTestimonials data-id="element-2958" data-mp="22xtmklevsktz" />
      <StakesSection data-id="element-2959" data-mp="22wiei9eekqx2" />
      <FinalCTA data-id="element-2960" data-mp="22vz032nyokns" />
    </div>;
}